import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import TrackStatusTabbedModal from "../../components/modals/asteraTrackStatus/trackStatusTabbedModal";
import SubmissionSummary from "../../components/modals/submissionSummary/submissionSummary";
import { useTablesContext } from "../../context/tablesContextProvider";
import { ModalId } from "../../enums/modalId";
import { TableNames } from "../../enums/tableNames";
import { useModalOpener } from "../../hooks/useModalOpener";
import { closeModal } from "../../redux/slice/modalSliceNew";
import { AppDispatch, RootState } from "../../redux/store/store";

/**
 * Layout shell for oncology submission routes.
 * Hosts shared modals (Submission Summary, Run Delivery Pipeline).
 */
const PharmaOncologySubmissionLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { metaData } = useSelector((state: RootState) => state.modalSliceNew);
  const { openedModalId } = useModalOpener();
  const { setTableDataForContext } = useTablesContext();

  /**
   * Closes the currently opened modal.
   */
  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  /**
   * Triggers an oncology submission table refetch after a successful modal action.
   */
  const handleSubmissionSuccess = () => {
    setTableDataForContext(TableNames.ONCOLOGY_SUBMISSION_ORDERS, {
      shouldRefetch: true,
    });
  };

  return (
    <div className="pharma-submission__layout flex h-full w-full overflow-hidden">
      <div className="pharma-submission__outlet w-full flex-1">
        <Outlet />
      </div>
      {openedModalId === ModalId.RUN_DELIVERY_PIPELINE_MODAL && (
        <TrackStatusTabbedModal
          action="deliveryPipeline"
          onClose={handleCloseModal}
          onSuccess={handleSubmissionSuccess}
        />
      )}
      {openedModalId === ModalId.SUBMISSION_SUMMARY_MODAL &&
        metaData &&
        "data" in metaData && (
          <SubmissionSummary
            showCallFields
            onClose={handleCloseModal}
            metaData={metaData as { data: any }}
            onSuccess={handleSubmissionSuccess}
          />
        )}
    </div>
  );
};

export default PharmaOncologySubmissionLayout;
